import { generateKeys } from '../utils';
export const userActivityLogGraphqlTypes = generateKeys({
    userCreation: {
        name: 'UserCreation',
        value: 'user_creation',
    },
    userActivation: {
        name: 'UserActivation',
        value: 'user_activation',
    },
    userDeactivation: {
        name: 'UserDeactivation',
        value: 'user_deactivation',
    },
    roleChange: {
        name: 'RoleChange',
        value: 'role_change',
    },
    profileChange: {
        name: 'ProfileChange',
        value: 'profile_change',
    },
    documentTranslation: {
        name: 'DocumentTranslation',
        value: 'document_translation',
    },
    websiteTranslation: {
        name: 'WebsiteTranslation',
        value: 'website_translation',
    },
});
export const userActivityLogTypes = generateKeys({
    userCreation: {
        value: 'user_creation',
        label: 'User creation',
        logMessage: 'User created',
        graphqlType: userActivityLogGraphqlTypes.userCreation,
    },
    userActivation: {
        value: 'user_activation',
        label: 'User activation',
        logMessage: 'User activation',
        graphqlType: userActivityLogGraphqlTypes.userActivation,
    },
    userDeactivation: {
        value: 'user_deactivation',
        label: 'User deactivation',
        logMessage: 'User deactivated',
        graphqlType: userActivityLogGraphqlTypes.userDeactivation,
    },
    roleChange: {
        value: 'role_change',
        label: 'Role change',
        logMessage: 'Role changed',
        graphqlType: userActivityLogGraphqlTypes.roleChange,
    },
    profileChange: {
        value: 'profile_change',
        label: 'Profile change',
        logMessage: 'Profile changed',
        graphqlType: userActivityLogGraphqlTypes.profileChange,
    },
    documentTranslation: {
        value: 'document_translation',
        label: 'Document translation',
        logMessage: 'Document translated',
        graphqlType: userActivityLogGraphqlTypes.documentTranslation,
    },
    websiteTranslation: {
        value: 'website_translation',
        label: 'Website translation',
        logMessage: 'Website translated',
        graphqlType: userActivityLogGraphqlTypes.websiteTranslation,
    },
});
